// extracted by mini-css-extract-plugin
export default {"legendStyleContainer":"ReportsGraph_legendStyleContainer__1QlBG","itemsStyleContainer":"ReportsGraph_itemsStyleContainer__r1SrQ"};